import type {
  BulkReviewSetOperationBlock,
} from '../../../services/bulkPricingReview/bulkPricingReview.types';

export type BulkJobRowLike = {
  setOperations?: BulkReviewSetOperationBlock[] | null;
};

/** Variant ID targeted by this row's first set-price operation, or undefined. */
export function getPrimaryVariantIdFromJobRow(row: BulkJobRowLike): string | undefined {
  return row.setOperations?.[0]?.setVariantPrice?.variantId;
}

/** All unique variant IDs across every setVariantPrice entry in this row. */
export function getAllVariantIdsFromJobRow(row: BulkJobRowLike): string[] {
  if (!row.setOperations) return [];
  const ids: string[] = [];
  for (const op of row.setOperations) {
    const id = op?.setVariantPrice?.variantId;
    if (id && !ids.includes(id)) ids.push(id);
  }
  return ids;
}
